export default {
  categories_produtos: [],
  product_by_categorie: [],
  quantity_product_by_categorie: 1,
  choiced_product:'',
  all_products:[]
}
